var loadError;
var loadedAPN;
export function loadAPN() {
  return import(/* webpackPrefetch: true */
  /* webpackChunkName: "apn" */
  'awesome-phonenumber').then(apn => {
    loadedAPN = {
      parsePhoneNumber: apn.parsePhoneNumber,
      getAsYouType: apn.getAsYouType,
      getExample: apn.getExample
    };
    return loadedAPN;
  }, error => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    loadError = error;
    throw error;
  });
}
export function getAPN() {
  if (loadError) {
    throw loadError;
  }
  if (!loadedAPN) {
    // eslint-disable-next-line @typescript-eslint/no-throw-literal
    throw loadAPN();
  }
  return loadedAPN;
}